import styled from "styled-components";

export const Container = styled.div`
  button {
    margin: 0 !important;
    height: 48px;
    font-size: 1rem;
    font-weight: bold;
  }
`;
